// quill's root entry point re-exports Quill but not Delta — the type lives on core.
import type { Delta } from 'quill/core'
import type Clipboard from 'quill/modules/clipboard'

import { RICH_TEXT_FORMATS, SUMMARY_TABLE_BLOT } from './consts'
import { preserveSummaryTable } from './summary-table'

/**
 * Quill's clipboard converter only treats block elements as line boundaries, so the newline that
 * follows a `<br>` in pretty-printed HTML survives as a leading space on the next line — which
 * indented every continuation line of a generated assessment summary (ENG-3937). Runs after
 * Quill's own text matcher, so at most one space is ever left to drop.
 */
export const stripFormattingSpaceAfterBreak = (node: Node, delta: Delta) => {
  const firstInsert = delta.ops[0]?.insert

  if (
    node.previousSibling?.nodeName === 'BR' &&
    typeof firstInsert === 'string' &&
    firstInsert.startsWith(' ')
  ) {
    return delta.slice(1)
  }

  return delta
}

export const editorFormats = (preserveTables: boolean) =>
  preserveTables ? [...RICH_TEXT_FORMATS, SUMMARY_TABLE_BLOT] : [...RICH_TEXT_FORMATS]

// Applies to programmatic inserts and user pastes alike, so it belongs in every editor.
export const editorClipboardMatchers = (preserveTables: boolean) => {
  const matchers: Clipboard['matchers'] = [[Node.TEXT_NODE, stripFormattingSpaceAfterBreak]]
  if (preserveTables) matchers.push(['table', preserveSummaryTable])
  return matchers
}
